// frontend/src/services/supportService.js
import api from "./api";

export async function sendSupportMessage(payload) {
  const response = await api.post("/support/chat", {
    message: payload.message,
    current_route: payload.current_route || null,
    current_module: payload.current_module || null,
    page_title: payload.page_title || null,
  });

  return response.data;
}

export async function fetchHelpArticles(params = {}) {
  const response = await api.get("/support/help/articles", {
    params: {
      category: params.category || undefined,
      module: params.module || undefined,
    },
  });

  return response.data;
}

export async function searchHelp(query, params = {}) {
  const response = await api.get("/support/help/search", {
    params: {
      q: query,
      current_route: params.current_route || undefined,
      current_module: params.current_module || undefined,
      limit: params.limit || 10,
    },
  });

  return response.data;
}

export async function sendSupportFeedback(payload) {
  const response = await api.post("/support/feedback", {
    chain_id: payload.chain_id || null,
    question: payload.question,
    answer: payload.answer,
    helpful: payload.helpful,
    current_route: payload.current_route || null,
    current_module: payload.current_module || null,
    page_title: payload.page_title || null,
    provider_used: payload.provider_used || null,
    model_used: payload.model_used || null,
    sources: payload.sources || [],
  });

  return response.data;
}